export const iconFontAwesomeNatureSpider = (
	<i className="fa-solid fa-spider"></i>
);
